import { EmailAlertTimelineTab } from './EmailAlertTimelineTab';
import { getSonarObjectTypeLabel } from '@sonar-software/sonar-ts-lib';
import { PeriscopeBodyComponent } from '@periscopes/types';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';

import { COPY_SONAR_OBJECT_BASE, PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import { EmailAlertMetadataTab, EmailAlertWorkflowRulesTab } from '.';
import { PeriscopeMenuTabs, PeriscopeTabArea } from '@periscopes/general';
import { useOnMount, usePeriscopeActions } from '@hooks';

export const EmailAlertScope: PeriscopeBodyComponent = ({ data, index }) => {
	const { relatedCounts, sonarObjectId } = data;
	const { updatePeriscope } = usePeriscopeActions();

	useOnMount(() => {
		updatePeriscope({
			headerLabel: COPY_SONAR_OBJECT_BASE.WORKFLOW_ACTION,
			periscopeIndex: index,
			subType: getSonarObjectTypeLabel(data.sonarObjectType)
		});
	});

	return (
		<PeriscopeMenuTabs>
			<PeriscopeTabArea
				key={ PERISCOPE_TAB_TYPES.DETAILS }
				tab={ PERISCOPE_TAB_TYPES.DETAILS }>
				<EmailAlertMetadataTab
					index={ index }
					sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.SalesforceWorkflowRule ] ?? 0 }
				key={ PERISCOPE_TAB_TYPES.WORKFLOW_RULES }
				requiresCount
				tab={ PERISCOPE_TAB_TYPES.WORKFLOW_RULES }>
				<EmailAlertWorkflowRulesTab
					index={ index }
					sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				key={ PERISCOPE_TAB_TYPES.ACTIVITY }
				tab={ PERISCOPE_TAB_TYPES.ACTIVITY }>
				<EmailAlertTimelineTab sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
		</PeriscopeMenuTabs>
	);
};
